<template>
  <div id="PrintSessionView">
    <div v-if="PrintSessionShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>
          <div>
            參與招生宣導人次報表:<br />
            <select v-model="queryInfo.options1Value">
              <!--<option selected="selected" value="">請選擇</option>-->
              <option
                v-for="item in options1"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option></select
            ><br />
          </div>

          <!-- <div>
            系名稱：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.dptcdName"
              placeholder="系名稱"
            />
          </div>
          <div>
            學院名稱：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.gidName"
              placeholder="學院名稱"
            />
          </div> -->
          <div>
            宣導人員：<br />
            <input
              type="text"
              class="form-control"
              v-model="queryInfo.updateUserName"
              placeholder="宣導人員"
            />
          </div>
          <button
            href="#"
            @click.prevent="getALLSessionList()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>
          <button
            href="#"
            @click.prevent="reset()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            清除重來
          </button>

          <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX1_1/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(queryInfo.options1Value)
                .concat('/')
                .concat(queryInfo.updateUserName)
            "
            v-show="total > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
        </div>
        <div v-if="queryShow">
          活動開始日期：{{ queryInfo.sActiveTime }}至活動結束日期{{ queryInfo.eActiveTime }}

        </div>
      </div>

      <b-tabs
        v-model="currentPage"
        @input="handleTabChange"
        content-class="mt-3"
        justified
      >
        <b-tab title="學院" >
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">合計人次\學院</th>
                  <b-th style="min-width: 2em">工程學院</b-th>
                  <b-th style="min-width: 3em">電資學院</b-th>
                  <b-th style="min-width: 3em">管理學院</b-th>
                  <b-th style="min-width: 3em">文創學院</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-if="inputData && inputData.length > 0">
                  <b-td style="text-align: center"> 合計人次 </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList1 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList2 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList3 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList4 }}</b-td
                  >
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="教學單位">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">合計人次\教學單位</th>
                  <b-th style="min-width: 2em">化材系</b-th>
                  <b-th style="min-width: 2em">冷凍系</b-th>
                  <b-th style="min-width: 2em">智動系</b-th>
                  <b-th style="min-width: 2em">機械系</b-th>
                  <b-th style="min-width: 2em">智慧系</b-th>
                  <b-th style="min-width: 2em">資工系</b-th>
                  <b-th style="min-width: 2em">電子系</b-th>
                  <b-th style="min-width: 2em">電機系</b-th>
                  <b-th style="min-width: 2em">工管系</b-th>
                  <b-th style="min-width: 2em">企管系</b-th>
                  <b-th style="min-width: 2em">健康系</b-th>
                  <b-th style="min-width: 2em">行流系</b-th>
                  <b-th style="min-width: 2em">資管系</b-th>
                  <b-th style="min-width: 2em">景觀系</b-th>
                  <b-th style="min-width: 2em">文創系</b-th>
                  <b-th style="min-width: 2em">應英系</b-th>
                  <b-th style="min-width: 2em">精密製造科技研究所</b-th>
                  <b-th style="min-width: 2em">前瞻電資科技研究所</b-th>
                  <b-th style="min-width: 2em">智慧製造與資訊應用國際碩士學位學程</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-if="inputData && inputData.length > 0">
                  <b-td style="text-align: center"> 合計人次 </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList1 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList2 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList3 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList4 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList5 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList6 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList7 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList8 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList9 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList10 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList11 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList12 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList13 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList14 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList15 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList16 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList17 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList18 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList19 }}</b-td
                  >
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="行政單位">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">合計人次\行政單位</th>
                  <b-th style="min-width: 2em">校長室</b-th>
                  <b-th style="min-width: 3em">秘書室</b-th>
                  <b-th style="min-width: 3em">招生處</b-th>
                  <b-th style="min-width: 3em">推廣部</b-th>
                  <b-th style="min-width: 3em">教務處</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-if="inputData && inputData.length > 0">
                  <b-td style="text-align: center"> 合計人次 </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList1 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList2 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList3 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList4 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList5 }}</b-td
                  >
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="系主任">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">合計人次\教學單位</th>
                  <b-th style="min-width: 2em">化材系</b-th>
                  <b-th style="min-width: 2em">冷凍系</b-th>
                  <b-th style="min-width: 2em">智動系</b-th>
                  <b-th style="min-width: 2em">機械系</b-th>
                  <b-th style="min-width: 2em">智慧系</b-th>
                  <b-th style="min-width: 2em">資工系</b-th>
                  <b-th style="min-width: 2em">電子系</b-th>
                  <b-th style="min-width: 2em">電機系</b-th>
                  <b-th style="min-width: 2em">工管系</b-th>
                  <b-th style="min-width: 2em">企管系</b-th>
                  <b-th style="min-width: 2em">健康系</b-th>
                  <b-th style="min-width: 2em">行流系</b-th>
                  <b-th style="min-width: 2em">資管系</b-th>
                  <b-th style="min-width: 2em">景觀系</b-th>
                  <b-th style="min-width: 2em">文創系</b-th>
                  <b-th style="min-width: 2em">應英系</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-if="inputData  && inputData.length > 0">
                  <b-td style="text-align: center"> 合計人次 </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList1 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList2 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList3 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList4 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList5 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList6 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList7 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList8 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList9 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList10 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList11 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList12 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList13 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList14 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList15 }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ inputData[0].gidList16 }}</b-td
                  >
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="化材系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="冷凍系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="智動系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="機械系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="智慧系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="資工系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="電子系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="電機系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="工管系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="企管系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="健康系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="行流系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="資管系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="景觀系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="文創系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="應英系">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="個人查詢">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}</b-td
                  >
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="招生處">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="校長室">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="秘書室">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="推廣部">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="教務處">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="體育室">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX6/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
                .concat('/')
                .concat(1)
                .concat('/')
                .concat(data.name)
            "
            v-show="data.number > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>{{ data.number }}

                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

        <b-tab title="精密製造科技研究所">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="前瞻電資科技研究所">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>
        <b-tab title="智慧製造與資訊應用國際碩士學位學程">
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr>
                  <th style="min-width: 2em">姓名</th>
                  <b-th style="min-width: 2em">人次</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in inputData" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{
                      data.deparment +
                      data.pro_Title +
                      data.name +
                      "(" +
                      data.updateUser +
                      ")"
                    }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.number }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-tab>

      </b-tabs>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "PrintSessionView",
  data() {
    return {
      queryShow:false,
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      PrintSessionShow: false,
      options1Value: 1,
      options1: [

        { value: 1, text: "學院" },
        { value: 2, text: "教學單位" },
        { value: 3, text: "行政單位" },
        { value: 4, text: "系主任" },
        { value: 5, text: "化材系" },
        { value: 6, text: "冷凍系" },
        { value: 7, text: "智動系" },
        { value: 8, text: "機械系" },
        { value: 9, text: "智慧系" },
        { value: 10, text: "資工系" },
        { value: 11, text: "電子系" },
        { value: 12, text: "電機系" },
        { value: 13, text: "工管系" },
        { value: 14, text: "企管系" },
        { value: 15, text: "健康系" },
        { value: 16, text: "行流系" },
        { value: 17, text: "資管系" },
        { value: 18, text: "景觀系" },
        { value: 19, text: "文創系" },
        { value: 20, text: "應英系" },
        { value: 21, text: "個人查詢" },
        { value: 22, text: "招生處" },
        { value: 23, text: "校長室" },
        { value: 24, text: "秘書室" },
        { value: 25, text: "推廣部" },
        { value: 26, text: "教務處" },
        { value: 27, text: "體育室" },
        { value: 28, text: "精密製造科技研究所" },
        { value: 29, text: "前瞻電資科技研究所" },
        { value: 30, text: "智慧製造與資訊應用國際碩士學位學程" },

      ],
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected1: null,
      editId: 0,
      over: 0,
      total: 1,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        defaultDate: "2024-01-01", // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
        activeClassSn: 0,   // 宣導類型
        functionValue:2 
      },
    };
  },
  components: {
    flatPickr,
  },
  methods: {
    handleTabChange() {
      this.queryInfo.options1Value = this.currentPage + 1;

      this.getALLSessionList();
    },
    getActiveTime() {
      let vm = this;
      if (tools.empty(vm.queryInfo.sActiveTime)) {
        vm.queryInfo.sActiveTime = vm.flatpickrConfig.default;
      }
      if (tools.empty(vm.queryInfo.eActiveTime)) {
        vm.queryInfo.eActiveTime = vm.flatpickrConfig.default;
      }

      if (!tools.empty(vm.queryInfo.sActiveTime)) {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
        // 提取日期部分
        vm.queryInfo.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (!tools.empty(vm.queryInfo.eActiveTime)) {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
        // 提取日期部分
        vm.queryInfo.eActiveTime = dateObject.toISOString().split("T")[0];
      }
    },
    reset() {
      let vm = this;
      vm.queryInfo = {
        sActiveTime: "2025-01-01",
        eActiveTime: "2025-01-01",
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
      };
      vm.PrintSessionShow = true;
   // vm.getALLSessionList();

    },

    getALLSessionList() {
      let vm = this;
      vm.queryShow=true;
      vm.currentPage = vm.queryInfo.options1Value - 1;

      vm.getActiveTime();
      this.$http
        .put("./WebApi/HighSchoolEnrolling/GetALLSessionList/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            console.log("vm.inputData", vm.inputData);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
  },

  created() {
    console.log("======created PrintSessionShow =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

   vm.PrintSessionShow = true;
   //vm.getALLSessionList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
